import { Link } from "react-router";

import { demoCreatorPortfolio } from "../product/demo-portfolio";
import { PostCard } from "../product/post-card";
import { getCreatorCollectionPath } from "../product/profile";

// Show the actual card component and live embed used by a public collection.
//
export function HeroPreview() {
  const { collections, posts, profile } = demoCreatorPortfolio;
  const collection = collections[0];
  const post = posts.find((item) => item.id === collection?.postIds[0]);
  if (!collection || !post) return null;
  const metadata = collection.postMetadata[post.id];
  return (
    <div className="bg-card mx-auto w-full max-w-xl rounded-3xl border p-3 shadow-xl sm:p-5">
      <p className="text-muted-foreground mb-3 text-xs font-medium">
        Example portfolio · real X post, sample context
      </p>
      <div className="mb-4 flex flex-wrap gap-2">
        {collections.map((item) => (
          <Link
            key={item.id}
            className="bg-muted rounded-full px-3 py-2 text-xs"
            to={getCreatorCollectionPath(profile, item)}
          >
            {item.title}
          </Link>
        ))}
      </div>
      <PostCard
        context={metadata?.note ?? ""}
        creatorHandle={profile.handle}
        post={post}
      />
      <Link
        className="mt-4 inline-block text-sm font-medium underline"
        to="/example"
      >
        Explore the full example
      </Link>
    </div>
  );
}
